import * as React from 'react';
import { connect } from 'react-redux';

import { __t, applyTranslations } from 'utils/language';
import { addProtocol } from 'utils/url';

import { Form, FormActions } from 'components/form';
import ActionButton from 'components/buttons/action-button/ActionButton';
import ProfileGeneralFormFields from './form/general/ProfileFormFieldsGeneral';

import type { Image, InfluencerProfileForm } from 'types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./i18n/profile-creation-common.i18n.json'));

type StateProps = {
  profileImage: Image | undefined | null
};

type OwnProps = {
  details: InfluencerProfileForm,
  onSubmit: (a: InfluencerProfileForm) => void,
  onCancel: (a: InfluencerProfileForm) => void,
  onInputFieldDescriptionShow: (a: SyntheticEvent<HTMLInputElement | HTMLOptionElement>) => void,
  onFieldDescriptionHide: () => void
};

type Props = StateProps & OwnProps;

type State = {
  details: InfluencerProfileForm
};

class ProfileCreationStepGeneral extends React.PureComponent<Props, State> {
  state = {
    details: {
      ...this.props.details
    }
  };

  prepareDetailsBeforeSaving() {
    const { profileImage } = this.props;
    const { details: { agencyDetails, ...otherDetails } } = this.state;
    const isAgencyManaged = Boolean(agencyDetails && agencyDetails.name && agencyDetails.url);

    return {
      ...otherDetails,
      profileImage,
      agencyDetails: isAgencyManaged ? { ...agencyDetails, url: addProtocol(agencyDetails && agencyDetails.url) } : null,
      isAgencyManaged
    } as InfluencerProfileForm;
  }

  handleDetailsChanged = (details: InfluencerProfileForm): void => {
    this.setState(state => ({
      details: {
        ...state.details,
        ...details
      }
    }));
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;

    onSubmit(this.prepareDetailsBeforeSaving());
  };

  handleCancel = () => {
    const { onCancel } = this.props;

    onCancel(this.prepareDetailsBeforeSaving());
  };

  render() {
    const { onInputFieldDescriptionShow, onFieldDescriptionHide } = this.props;
    const { details } = this.state;

    return (
      <section
        className="influencer-create-profile__form-container"
        data-qa="profile-creation-step-general"
      >
        <Form
          className="influencer-create-profile__form-container-inner-block"
          onSubmit={this.handleSubmit}
        >
          <ProfileGeneralFormFields
            isOnCreateStep
            details={details}
            onInputFieldDescriptionShow={onInputFieldDescriptionShow}
            onFieldDescriptionHide={onFieldDescriptionHide}
            onChange={this.handleDetailsChanged}
          />
          <FormActions align="center">
            <ActionButton
              color="tertiary"
              onClick={this.handleCancel}
            >
              {__t('profile_creation_common.buttons.button_back')}
            </ActionButton>
            <ActionButton
              color="primary"
              type="submit"
            >
              {__t('profile_creation_common.buttons.button_continue')}
            </ActionButton>
          </FormActions>
        </Form>
      </section>
    );
  }
}

const mapStateToProps = ({ influencerImages }): StateProps => ({
  profileImage: influencerImages.profileImage
});

export default connect(mapStateToProps)(ProfileCreationStepGeneral);
